<ds-search-bar
  [fullKeyword]="'search_by_workspace_or_digital_asset' | translate"
  [allowEmptySearch]="true"
  (search)="onSearch($event)"
></ds-search-bar>

@if (recentNavItems$ | async; as recentNavItems) {
  @if (recentNavItems.length > 0) {
    <nav data-test-id="recent-digital-assets" aria-labelledby="switcher-recent-title">
      <h3 id="switcher-recent-title" class="section-title">{{ 'recent_digital_assets' | translate }}</h3>
      <ds-list-menu [menuItems]="recentNavItems" [menuAriaLabel]="'recent_digital_assets' | translate"></ds-list-menu>
    </nav>
  }
}

<nav data-test-id="tree-nav" aria-labelledby="switcher-tree-title">
  <h3 id="switcher-tree-title" class="section-title">{{ 'all_workspaces_and_assets' | translate }}</h3>
  <ds-tree-menu
    [menuItems]="navItems$ | async"
    [menuAriaLabel]="'all_workspaces_and_assets' | translate"
    [rootItemsAlwaysExpanded]="true"
  ></ds-tree-menu>
</nav>
